import React, { useRef, useEffect, useState } from 'react';
import paper from 'paper';
import ProgressBar from '../ProgressBar';

const Sensations = ({
  waveCount = 10,
  waveColors = ['blue', 'red', 'lightgreen', 'blue', 'orange', 'blue', 'violet', 'white', 'cyan', 'blue',],
  waveSpeeds = [0.010, 0.003, 0.005, 0.001, 0.008, 0.002, 0.003, 0.005, 0.001, 0.008],
  documentBackgroundColor = 'white',
  amps = [2,3,2,3,2, 2,3,2,3,2],
  fillColor = 'black',
  barColor = 'rgba(0,0,0,0.45)',
  texts = [
    {
      text: 'Hello!',
      count: 200,
      fontSize: 50,
    },
    {
      text: 'Welcome to the firesale!',
      count: 400,
      fontSize: 100,
    },
    {
      text: "I'm glad you're here. I was so",
      count: 600,
      fontSize: 50,
    },
    {
      text: "lonely phoney macaroni. \n \n But now I'm so",
      count: 800,
      fontSize: 50,
    },
    {
      text: "happy, just happy :)",
      count: 1000,
      fontSize: 50,
    },
    {
      text: "Now try some complimentary: \n \n ice cream cake \n lemon bake \n or chocolate shake",
      count: 1400,
      fontSize: 50,
    },
    {
      text: "",
      count: 1600,
      fontSize: 50,
    }
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize,
  },
}) => {
  const canvasRef = useRef(null);
  const waves = useRef([]);
  const mouseAmplitude = useRef(100);
  const barRef = useRef({ index: 0, counter: 0 });
  const [barProgress, setBarProgress] = useState({ index: 0, counter: 0 });

  const setupWaves = () => {
    for (let i = 0; i < waveCount; i++) {
      const wave = new paper.Path();
      wave.strokeColor = waveColors[i % waveColors.length];
      wave.strokeWidth = 100;
      waves.current.push(wave);
    }
    return waves;
  };

  const updateWaves = (waves) => {
    let counter = -10;
    waves.forEach((wave, i) => {
      const time = Date.now() * waveSpeeds[i];
      wave.segments = [];
      for (let x = -10; x <= paper.view.size.width; x += 1) {
        const y = mouseAmplitude.current * amps[i] * Math.sin(x * 0.05 + time + i * 20) + paper.view.size.height / 2;
        wave.add(new paper.Point(y+50 + counter, x+100));
        counter += 0.05;
      }
    });
  };

  useEffect(() => {
    paper.setup(canvasRef.current);

    setupWaves(waves.current);

    const displayText = new paper.PointText({
      point: [paper.view.size.width/2, paper.view.size.height/2],
      content: texts[0].text,
      ...content,
    });
    displayText.fillColor = fillColor;

    const onMouseMove = (event) => {
      mouseAmplitude.current = (paper.view.size.height - event.point.y) / 5;
      displayText.point = event.point;
      document.body.style.backgroundColor = documentBackgroundColor;

      const bar = barRef.current;
      if (bar.index < texts.length - 1) bar.counter += 1;
      if (bar.counter > texts[bar.index].count) {
        bar.index += 1;
        displayText.content = texts[bar.index].text;
        displayText.fontSize = texts[bar.index].fontSize;
      }
      setBarProgress({ index: bar.index, counter: bar.counter });
    };

    const onFrame = () => {
      updateWaves(waves.current);
    };

    paper.view.on('mousemove', onMouseMove);
    paper.view.on('frame', onFrame);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.view.off('frame', onFrame);
      paper.project.clear();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
      <ProgressBar
        texts={texts}
        index={barProgress.index}
        counter={barProgress.counter}
        color={barColor}
      />
    </div>
  );
};

export default Sensations;
